import React from 'react';
var clearfix = /*#__PURE__*/React.createElement("div", {
  className: "clear"
});
export var Clearfix = function Clearfix() {
  return clearfix;
};